<template>
	<div class="project-page">
		<div class="agent-hero">
			<div>
				<div class="hero-kicker">AI Agent Gallery</div>
				<h2>智能体广场</h2>
				<p>按类型浏览可用智能体与工作流，快速查看设计说明和最近更新。</p>
			</div>
			<div class="hero-right-group">
				<div class="hero-count">
					<span>{{ totalCount }}</span>
					<small>个智能体</small>
				</div>
				<!-- 筛选下拉按钮 -->
				<el-dropdown  trigger="click" ref="filterDrop" @visible-change="handleFilterVisible"
					@command="handleFilterChange">
					<span class="filter-icon-btn" title="筛选">
						<i class="el-icon-s-operation"></i>
					</span>
					<!-- 直接渲染类型选项，无el-select -->
					<el-dropdown-menu slot="dropdown" class="filter-dropdown-menu">
						<el-dropdown-item v-for="item in modelSourceList" :key="item.value" :command="item.value"
							:class="{active: queryParams.typeCode === item.value}">
							{{ item.label }}
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>

		</div>

		<div class="card-wrap" ref="scrollContainer" @scroll="onScroll">
			<div class="card-grid">
				<div class="project-card" v-for="item in projectList" :key="item.id">
					<!-- 右上角三点下拉菜单 -->
					<el-dropdown trigger="click" @command="(cmd) => handleMenuClick(cmd, item)" class="card-more-wrap">
						<div class="more-btn">
							<i class="el-icon-more" style="transform: rotate(90deg);color: #409EFF;"></i>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="menuItem in cardMenuList.filter(v=>(v.code==item.aiTypeCode)||v.code!='html')" :key="menuItem.code"
								:command="menuItem.code">
								{{ menuItem.label }}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<div class="card-title-row">
						<span class="title">{{ item.name }}</span>
						<span class="tag green-tag" v-if="item.hasCheck">✓</span>
					</div>
					<p class="card-desc" :title="item.description">{{ item.description||"未描述"}}</p>
					<div class="card-bottom">
						<span class="type-tag">{{ foraiTypeCodeName(item.aiTypeCode) }}<span class="new-tag"
								v-if="item.isNew">New</span></span>
						<div class="author-line">
							<img src="@/ico/agentNmae.svg" style="width: 16px;height: 16px;" /> <span class="username"
								:title="item.userName">
								{{ item.userName }}
							</span>
							<span class="time">最近编辑 {{ formatTsToDate(item.time)||"--"}}</span>
						</div>
					</div>
					<div class="card-icon">
						<img :src="item.url" class="cover-img" />
						<div class="icon-placeholder"></div>
					</div>
				</div>
			</div>
			<div class="load-tip" v-if="loading">
				<i class="el-icon-loading" style="font-size: 30px;color: #409EFF;"></i><span
					style="font-size: 30px;color: #409EFF;"> 加载中...</span>
			</div>
			<div class="load-tip no-more" v-if="noMore&&totalCount>10">我是有底线的！</div>
		</div>
		<el-dialog title="设计说明" :visible.sync="isView" width="80vw" top="0" :before-close="noView" append-to-body
			:z-index="2999" style="overflow: hidden; height: 80vh; margin: 0; padding: 0; margin-top: calc(10vh);">
			<div style="width:100%;flex:1;display:flex;flex-direction:column;height: 70vh;">
				<div
					style="flex:1; overflow-y:auto; display:flex; justify-content:center; align-items:flex-start; padding:10px;">
					<img :src="designDrawing" alt="设计图纸" style="max-width: 100%; object-fit: contain; display:block;" />
				</div>
			</div>
		</el-dialog>
		<el-dialog title="网页智能体模拟" title-align="center" :visible.sync="isHtml" width="100%" top="0" :before-close="handleCloseDialog"
			:modal-append-to-body="true" style="overflow-y: hidden;height:100%;">
			<div style=" width:100%;height:calc(100vh - 120px);">
				<HtmlPlayView :key="dialogKey" :url="htmlSrc" :iframeUrlOrigin="iframeUrlOrigin" :iframeUrlPlay="iframeUrlPlay" />
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import HtmlPlayView from '@/views/components/html/HtmlIframeView.vue'
	export default {
		
		name: "ProjectScrollPage",
		components: {
			HtmlPlayView
		},
		data() {
			return {
				//网页模拟器
				isHtml:false,
				iframeUrlPlay:null,
				iframeUrlOrigin:null,
				dialogKey:1,
				login:null,
				// 卡片右上角三点下拉菜单数据源（按需增删）
				cardMenuList: [{
						code: 'viewDesign',
						label: '查看设计'
					},
					{ code: 'html', label: '模拟功能' },
					// { code: 'del', label: '删除项目' }
				],
				// 筛选条件
				queryParams: {
					typeCode: "",
					projectStatus: ""
				},
				// 分页配置
				pageNum: 1,
				pageSize: 10, // 单次加载10条
				totalCount: 0, // 总条数（顶部展示）
				projectList: [], // 渲染列表
				loading: false, // 请求锁防重复请求
				noMore: false, // 是否触达最后一页
				modelSourceList: [{
						label: '全部类型',
						value: ''
					},
					{
						label: '扣子工作流',
						value: 'coze_flow'
					},
					{
						label: '扣子智能体',
						value: 'coze_bot'
					},
					{
						label: '火山引擎',
						value: 'volc'
					},
					{
						label: 'DeepSeek',
						value: 'deepseek'
					},
					{
						label: '千问百炼',
						value: 'dashScope'
					},
					{
						label: '网页',
						value: 'html'
					}
				],
				isView: false,
				htmlSrc:'',
				designDrawing: null,
				showFilterPanel: false,
			}
		},
		mounted() {
			this.fetchProjectList(true);
		},
		methods: {
			handleCloseDialog() {
				if (this.iframeUrlOrigin) URL.revokeObjectURL(this.iframeUrlOrigin);
				if (this.iframeUrlPlay) URL.revokeObjectURL(this.iframeUrlPlay);
				
				this.isHtml = false;
			},
			async viewHtml(item){
				this.loginOpen('网页智能体加载中...')
				console.log('item',item)
				
				try{
					if (item.htmlSrc) {
						//需要获取新的地址getDetail
						
						await this.loadOssHtml(item.htmlSrc)
						this.dialogKey += 1;
						this.isHtml = true;
					}
				}catch(err){
					
				}finally{
					this.noLogin()
				}
			},
			
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			async loadOssHtml(src) {
				let oss = await this.$oss.getDownloadUrl(src)
				this.htmlSrc=oss
				try {
					// 批量释放全部旧blob，防止浏览器回收空白页面
					const releaseBlob = (url) => {
						if (url && url.startsWith('blob:')) URL.revokeObjectURL(url);
					}
					releaseBlob(this.iframeUrlOrigin);
					releaseBlob(this.iframeUrlPlay);
					const blobUrl = await this.loadOssHtmlBlob(oss)
					// this.iframeSrc = URL.createObjectURL(blobUrl);
					this.iframeUrlOrigin = URL.createObjectURL(blobUrl);
					this.iframeUrlPlay = URL.createObjectURL(blobUrl);
					this.$message.success('网页智能体加载完成')
				} catch (err) {
					this.$message.error('读取OSS失败：' + err.message)
					console.error(err)
				}
			},
			async loadOssHtmlBlob(ossUrl) {
				try {
					const res = await fetch(ossUrl, {
						method: "GET",
						mode: "cors"
					});
					
					if (!res.ok) {
						throw new Error(`OSS请求失败，状态码：${res.status}，链接过期/无跨域权限`);
					}
					const rawBlob = await res.blob();
					const htmlBlob = new Blob([rawBlob], {
						type: "text/html;charset=utf-8"
					});
					
					return htmlBlob;
				} catch (err) {
					this.$message.error('读取OSS失败：' + err.message);
					console.error(err);
					return ''
				}
			},
			// 下拉菜单项点击回调：code=菜单标识，item=当前卡片数据
			handleMenuClick(cmd, cardItem) {
				this.htmlSrc=''
				switch (cmd) {
					case 'viewDesign':
						this.toViewDesign(cardItem)
						break
					case 'html':
						this.viewHtml(cardItem)
						break
					case 'del':
						console.log('删除', cardItem)
						break
				}
			},
			async toViewDesign(item) {
				if(item.a)
				if (item.designDrawing == '' || !item.designDrawing) return this.$message.success('暂无设计说明')
				try {
					this.designDrawing = await this.$oss.getDownloadUrl(item.designDrawing)
					this.isView = true
				} catch (err) {

				}

			},
			noView() {
				this.isView = false
				this.designDrawing = null

			},
			foraiTypeCodeName(val) {
				if (!val) return "未定义"
				let name = this.modelSourceList.find(v => v.value == val)?.label || "未定义"
				return name
			},
			formatTsToDate(timestamp) {
				if (!timestamp) return ''
				let time = Number(timestamp)
				// 判断是秒级时间戳（10位），转为毫秒
				if (time.toString().length === 10) {
					time = time * 1000
				}
				const date = new Date(time)
				// 补零函数 0~9 → 01、02
				const padZero = n => n < 10 ? '0' + n : n
				const year = date.getFullYear()
				const month = padZero(date.getMonth() + 1) // 月份从0开始
				const day = padZero(date.getDate())
				const hour = padZero(date.getHours())
				const minute = padZero(date.getMinutes())
				const second = padZero(date.getSeconds())
				return `${year}-${month}-${day} ${hour}:${minute}:${second}`
			},
			// 拉取分页数据 reset=true代表筛选变更重置分页
			async fetchProjectList(reset = false) {
			  if (this.loading) return;
			  this.loading = true;
			  if (reset) {
			    this.pageNum = 1;
			    this.projectList = [];
			    this.noMore = false;
			  }
			  try {
			    // 1. 请求分页基础数据
			    const res = await this.API.get(this.API.admin.getStandardModelAgentList, {
			      pageNum: this.pageNum,
			      pageSize: this.pageSize,
			      ...this.queryParams
			    })
			
			    const apiData = res?.data?.data || {};
			    const total = apiData.total || 0;
			    const records = Array.isArray(apiData.records) ? apiData.records : [];
			    this.totalCount = total;
			
			    // 先填充占位图，立即渲染列表
			    const tempList = records.map(item => {
			      const isNew = this.isLessSevenDay(item.createTime)
				  
			      return {
			        ...item,
			        url:item.promotionalImage? require('@/ico/loading.svg'):require('@/ico/agaenNo.png'), // 默认占位
			        isNew,
			        time: item.updateTime || item.createTime,
			        imgLoaded: false
			      }
			    })
			
			    // 追加列表，页面立刻渲染
			    if (tempList.length > 0) {
			      this.projectList.push(...tempList);
			    }
			    this.loading = false
			
			    // 分页逻辑不变
			    const loadedTotal = this.pageNum * this.pageSize;
			    if (loadedTotal >= total || records.length === 0) {
			      this.noMore = true;
			    } else {
			      this.pageNum += 1;
			    }
			
			    // 2. 串行加载图片：第一张完成再跑第二张，顺序从上到下
			    const loadImageSerial = async () => {
			      for (let i = 0; i < tempList.length; i++) {
			        const row = tempList[i];
			        const record = records[i];
			        // 无图片key直接跳过
			        if (!record.promotionalImage) continue;
			        try {
			          // 等待当前图片请求完成再循环下一条
			          const realUrl = await this.$oss.getDownloadUrl(record.promotionalImage);
			          if (!realUrl) continue;
			          // 找到列表对应数据更新图片
			          const target = this.projectList.find(p => p.id === record.id);
			          if (target) {
			            target.url = realUrl;
			            target.imgLoaded = true;
			          }
			        } catch (imgErr) {
			          console.error('图片加载失败', record.promotionalImage, imgErr);
			        }
			      }
			    }
			    // 后台执行图片加载，不阻塞页面渲染
			    loadImageSerial();
			
			  } catch (err) {
			    console.error("分页请求异常", err)
			  } finally {
			    this.loading = false;
			  }
			},
			isLessSevenDay(createTs) {
				if (!createTs) return false
				// 统一转毫秒时间戳
				let ts = Number(createTs)
				if (ts.toString().length === 10) ts *= 1000

				const now = Date.now()
				const sevenDayMs = 7 * 24 * 60 * 60 * 1000 // 7天毫秒数
				return now - ts < sevenDayMs
			},
			// 筛选下拉切换重置列表
			handleFilterChange(val) {
				this.queryParams.typeCode = val
				this.fetchProjectList(true)
				// 选完自动关闭下拉

			},
			handleFilterVisible(visible) {

			},
			// handleFilterChange() {
			// 	this.fetchProjectList(true);
			// },
			// 滚动监听逻辑（下滑触底加载）
			onScroll(e) {
				if (this.loading || this.noMore) return;
				const dom = e.target;
				// 距离底部阈值50px就触发下一页
				const bottomGap = dom.scrollHeight - dom.scrollTop - dom.clientHeight;
				if (bottomGap <= 50) {
					this.fetchProjectList();
				}
			}
		}
	}
</script>
<style scoped>
	.project-page {
		padding: 16px;
		box-sizing: border-box;
	}

	.filter-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 18px;
		gap: 12px;

		.filter-left {
			display: flex;
			align-items: center;
			gap: 14px;


			el-select {
				width: 100px;
			}

			/* 下拉输入框圆角 */
			:deep(.el-select__wrapper) {
				border-radius: 6px;
				/* 圆角大小按需改，4/6/8px */
			}

			.total-text {
				font-size: 14px;
				color: #606266;
				margin-left: 8px;
			}
		}
	}

	.card-wrap {
		max-height: calc(100vh - 90px);
		overflow-y: auto;
		padding-right: 6px;
	}

	.card-grid {
		display: grid;
		/* grid-template-columns: repeat(3, 1fr);*/
		grid-template-columns: repeat(auto-fill, minmax(280px, 430px));
		gap: 18px;
	}

	.username {
		display: inline-block;
		max-width: 80px;
		/* 根据6个字宽度自行调整 */
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.project-card {
		background: #fff;
		border-radius: 12px;
		padding: 18px;
		position: relative;
		border: 1px solid #eee;
		/* hover卡片底色变更（匹配示例浅灰） */
		transition: background-color .2s;
	}

	.project-card:hover {
		background-color: #f7f7f7;
	}

	/* 右上角下拉容器定位 */
	.card-more-wrap {
		position: absolute;
		right: 14px;
		bottom: 14px;
		z-index: 5;
	}

	.more-btn {
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 10px;
		cursor: pointer;
		/* 默认隐藏三点按钮 */
		opacity: 0;
		transition: opacity .2s;
		background: #fff;
		box-shadow: 0 1px 4px #00000012;
	}

	/* 卡片hover时展示三点按钮 */
	.project-card:hover .more-btn {
		opacity: 1;
	}

	.more-btn:hover {
		background: #f1f1f1;
	}

	.card-title-row {
		display: flex;
		align-items: center;
		gap: 6px;
		font-size: 17px;
		font-weight: 600;
		margin-bottom: 8px;

		.green-tag {
			color: #27ae60;
			font-size: 13px;
		}
	}

	.card-desc {
		font-size: 16px ;
		color: #747880;
		text-indent: 2em !important;
		line-height: 1.5;
		margin-bottom: 14px;
		/* 强制固定3行高度，统一卡片布局 */
		height: 72px;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
		max-width: 80%;
		word-wrap: break-word;
		word-break: break-all;
	}

	.card-bottom {
		display: flex;
		flex-direction: column;
		gap: 8px;

		.type-tag {
			font-size: 12px;
			background: #f3f4f6;
			padding: 3px 8px;
			border-radius: 6px;
			width: fit-content;

			/* 宽度自适应文字内容 */
			.new-tag {
				color: #2563eb;
				margin-left: 4px;
			}
		}

		.author-line {
			font-size: 12px;
			color: #6b7280;
			display: flex;
			gap: 4px;
			align-items: center;
		}
	}

	.card-icon {
		position: absolute;
		right: 16px;
		top: 16px;
		width: 80px;
		height: 80px;
		border-radius: 10px;
		overflow: hidden;

		.icon-placeholder {
			width: 100%;
			height: 100%;
			background: #f1f5f9;
		}
	}

	.load-tip {
		text-align: center;
		padding: 16px 0;
		font-size: 13px;
		color: #9ca3af;

		&.no-more {
			color: #6b7280;
		}
	}

	/* 适配小屏幕卡片列数 */
	@media (max-width: 1100px) {
		.card-grid {
			grid-template-columns: repeat(2, 1fr);
		}
	}

	@media (max-width: 650px) {
		.card-grid {
			grid-template-columns: 1fr;
		}
	}

	.card-icon {
		position: absolute;
		right: 16px;
		top: 16px;
		width: 80px;
		height: 80px;
		border-radius: 10px;
		overflow: hidden;

		.cover-img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

	}

	.agent-hero {
		position: relative;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 18px;
		min-height: 118px;
		margin-bottom: 16px;
		padding: 22px 24px;
		border-radius: 18px;
		background:
			radial-gradient(circle at 92% 8%, rgba(255, 255, 255, .9), transparent 28%),
			linear-gradient(135deg, #eef7ff 0%, #ffffff 48%, #edf7f4 100%);
		border: 1px solid rgba(126, 154, 186, .16);
		box-shadow: 0 18px 42px rgba(31, 65, 105, .09);
	}

	.agent-hero::after {
		content: "AI";
		position: absolute;
		right: 118px;
		top: 12px;
		font-size: 76px;
		line-height: 1;
		font-weight: 900;
		color: rgba(64, 158, 255, .1);
		pointer-events: none;
	}

	.hero-kicker {
		color: #2f80ed;
		font-size: 12px;
		font-weight: 800;
		letter-spacing: .08em;
		text-transform: uppercase;
	}

	.agent-hero h2 {
		margin: 6px 0 8px;
		font-size: 28px;
		line-height: 1.2;
		color: #172033;
		letter-spacing: 0;
	}

	.agent-hero p {
		margin: 0;
		color: #667085;
		font-size: 14px;
	}

	.hero-count {
		min-width: 112px;
		padding: 14px 16px;
		border-radius: 16px;
		background: rgba(255, 255, 255, .72);
		border: 1px solid rgba(64, 158, 255, .16);
		text-align: center;
		box-shadow: inset 0 1px 0 rgba(255, 255, 255, .8);
	}

	.hero-count span {
		display: block;
		font-size: 30px;
		font-weight: 900;
		line-height: 1;
		color: #2f80ed;
	}

	.hero-count small {
		display: block;
		margin-top: 5px;
		color: #667085;
		font-size: 12px;
	}

	.project-page {
		padding: 18px;
	}

	.filter-bar {
		margin-bottom: 16px;
		padding: 12px 14px;
		border-radius: 14px;
		background: rgba(255, 255, 255, .82);
		border: 1px solid rgba(126, 154, 186, .14);
		box-shadow: 0 10px 24px rgba(31, 65, 105, .06);
	}

	.card-wrap {
		max-height: calc(100vh - 240px);
		padding: 2px 6px 12px 2px;
	}

	.card-grid {
		grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
		gap: 16px;
	}

	.project-card {
		overflow: hidden;
		min-height: 184px;
		background:
			radial-gradient(circle at 94% 12%, rgba(64, 158, 255, .12), transparent 28%),
			linear-gradient(135deg, #ffffff 0%, #f8fbff 56%, #eef7ff 100%);
		border-radius: 16px;
		padding: 18px 18px 16px;
		border: 1px solid rgba(126, 154, 186, .16);
		box-shadow: 0 12px 30px rgba(31, 65, 105, .08);
		transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
	}

	.project-card:hover {
		transform: translateY(-3px);
		background:
			radial-gradient(circle at 94% 12%, rgba(64, 158, 255, .16), transparent 28%),
			linear-gradient(135deg, #ffffff 0%, #f8fbff 56%, #eef7ff 100%);
		box-shadow: 0 18px 44px rgba(31, 65, 105, .13);
		border-color: rgba(64, 158, 255, .28);
	}

	.more-btn {
		width: 34px;
		height: 34px;
		border-radius: 12px;
		background: rgba(255, 255, 255, .88);
		box-shadow: 0 8px 18px rgba(31, 65, 105, .1);
	}

	.card-title-row {
		font-size: 18px;
		font-weight: 800;
		color: #172033;
		padding-right: 96px;
	}

	.card-desc {
		font-size: 14px;
		color: #667085;
		text-indent: 0;
		line-height: 1.65;
		max-width: calc(100% - 96px);
	}

	.card-bottom .type-tag {
		background: rgba(47, 128, 237, .1);
		color: #2f80ed;
		padding: 4px 9px;
		border-radius: 999px;
		font-weight: 700;
	}

	.card-icon {
		width: 78px;
		height: 78px;
		border-radius: 18px;
		border: 1px solid rgba(255, 255, 255, .8);
		box-shadow: 0 14px 30px rgba(31, 65, 105, .14);
	}

	@media (max-width: 650px) {
		.project-page {
			padding: 10px;
		}

		.agent-hero {
			align-items: flex-start;
			padding: 18px;
			flex-direction: column;
		}

		.agent-hero h2 {
			font-size: 23px;
		}

		.hero-count {
			width: 100%;
			box-sizing: border-box;
		}

		.card-wrap {
			max-height: calc(100vh - 300px);
		}

		.card-desc {
			max-width: 100%;
			padding-right: 76px;
		}
	}

	.hero-right-group {
		display: flex;
		align-items: center;
		gap: 12px;
		/* 禁止换行 */
		flex-wrap: nowrap;
	}

	.filter-icon-btn {
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 12px;
		background: rgba(47, 128, 237, 0.1);
		cursor: pointer;
		transition: background 0.2s;
		font-size: 20px;
		color: #2f80ed;
		flex-shrink: 0;
		/* 强制不收缩，防止换行挤压 */
	}

	.filter-icon-btn:hover {
		background: rgba(47, 128, 237, 0.18);
	}

	/* 下拉菜单宽度适配 */
	:deep(.filter-dropdown-menu) {
		min-width: 140px !important;
	}

	/* 选中类型高亮蓝色文字 */
	:deep(.filter-dropdown-menu .active) {
		color: #409EFF;
		font-weight: bold;
	}
</style>